module.exports = __webpack_public_path__ + "img/시설이용고령자_old.c476ff08.png";